module.exports = __webpack_public_path__ + "img/73.5bf8e290.webp";